__webpack_require__.p = "/angular-micro-ui-in-react/shell-react-application/";